import React from 'react'

const Footer = () => {
  return (
    <footer className='footer'>
      <p>&copy; 2022 developed by </p> &nbsp; <a target="_blank" rel="noreferrer" href='https://arbodesign.ir' className='footerA'>arbodesign team</a>
    </footer>
  )
}

export default Footer
